import axios from 'axios'
import fetcher from '../../../../../../services/fetcher'
import { getErrorStatus } from '../../../../../../services/fetcher/utils'
import { sanitizeContent } from '../../../../../../utils'
import { sendDatadogError } from '../../../../services/datadog'
import {
  mapConnectorstoVendorList,
  mapIntegrationStream
} from '../../scenes/DataIntegrationsNew/utils'
// eslint-disable-next-line import/no-cycle
import { createMessage } from '../actions'

//  integrations - employees
export const SET_LAST_UPLOAD_DATE = 'SET_LAST_UPLOAD_DATE'

// integrations
export const SET_INTEGRATION_TYPES = 'SET_INTEGRATION_TYPES'
export const SET_ENABLED_INTEGRATIONS = 'SET_ENABLED_INTEGRATIONS'
export const SET_CONNECTORS = 'SET_CONNECTORS'
export const SET_INTEGRATION_STREAMS = 'SET_INTEGRATION_STREAMS'
export const SET_S3_UPLOAD_PROGRESS = 'SET_S3_UPLOAD_PROGRESS'
export const SET_OUTBOUND_INTEGRATION = 'SET_OUTBOUND_INTEGRATION'
export const SET_INTEGRATION_LOADER = 'SET_INTEGRATION_LOADER'
export const INTEGRATION_STREAMS_LOADER = 'INTEGRATION_STREAMS_LOADER'

export function getStreamCredentials(streamId, cb) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')
    axios({
      method: 'get',
      url: `/integrations/integration-stream-self-service/${streamId}/get-stream-credentials/`,

      headers: {
        Authorization: token,
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        cb(response.data)
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Oops! Somethings not right.',
              content: 'We could not get the credentials for this stream'
            },
            8000
          )
        )
        sendDatadogError('Could not retrieve credentials for the stream.', 'error', err.response)
      })
  }
}

export function getConnectors() {
  return async (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')
    try {
      let vendors = []
      let response
      let url = `/integrations/connectors`
      do {
        // eslint-disable-next-line no-await-in-loop
        response = await axios({
          method: 'get',
          url,

          headers: {
            Authorization: token,
            'Content-Type': 'application/json'
          }
        })

        const { results } = response.data
        vendors = vendors.concat(
          results.filter(({ vendor }) => vendor !== null).map(mapConnectorstoVendorList)
        )

        const inboundConnector = vendors.filter(
          (item) => item.connector_type === 'inbound' || item.connector_type === null
        )
        const outboundConnector = vendors.filter((item) => item.connector_type === 'outbound')

        dispatch({
          type: SET_CONNECTORS,
          data: inboundConnector
        })

        dispatch({
          type: SET_OUTBOUND_INTEGRATION,
          data: outboundConnector
        })

        dispatch({
          type: SET_INTEGRATION_LOADER,
          data: false
        })

        url = response.data && response.data.next
        if (url && url.startsWith('http:')) {
          url = url.replace('http:', 'https:')
        }
      } while (url)
    } catch (err) {
      dispatch(
        createMessage(
          {
            type: 'generic',
            level: 'danger',
            header: 'Oops! Somethings not right.',
            content: 'We could not get the list of connectors for the org'
          },
          8000
        )
      )
      sendDatadogError('Could not retrieve connectors for the org.', 'error', err.response)
    }
  }
}

export function getIntegrationStreams() {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    dispatch({
      type: INTEGRATION_STREAMS_LOADER,
      data: true
    })

    axios({
      method: 'get',
      url: `/integrations/integration-stream-self-service/`,
      headers: {
        Authorization: token
      }
    })
      .then((response) => {
        const integrations = response.data.results
        dispatch({
          type: SET_INTEGRATION_STREAMS,
          data: integrations
            .filter(({ vendor }) => vendor !== null)
            .map((stream) => mapIntegrationStream(stream))
        })
      })
      .catch((err) => {
        // eslint-disable-next-line  no-console
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Oops! Somethings not right.',
              content: 'We could not get the list of integrations for the org'
            },
            8000
          )
        )
        dispatch({
          type: INTEGRATION_STREAMS_LOADER,
          data: false
        })
        sendDatadogError('Could not retrieve integrations for the org.', 'error', err.response)
      })
  }
}

export async function getDatasetsForStream(streamId, _params = {}) {
  let paginationQuery = ``
  const { limit, offset, ordering, validation_status } = _params
  paginationQuery = `&limit=${limit}&offset=${offset}&order_by=${ordering}&validation_status=${validation_status}`

  try {
    const url = `/integrations/integration-stream-self-service/${streamId}/datasets/?stage=RAW${paginationQuery}`
    return await fetcher.get(url)
  } catch (error) {
    return getErrorStatus({ error })
  }
}

export async function getDatasetsForCisco(url) {
  try {
    return await fetcher.get(url)
  } catch (error) {
    return getErrorStatus({ error })
  }
}

export function getPreSignedUrlLogFile(s3_key, cb) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')
    return axios({
      method: 'get',
      url: `/integrations/log-file/?s3_key=${s3_key}`,

      headers: {
        Authorization: token,
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        cb(s3_key.split('/')[s3_key.split('/').length - 1], response.data?.url)
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Oops! Somethings not right.',
              content: 'We could not get the log file for this Import'
            },
            8000
          )
        )
        sendDatadogError('Could not retrieve integrations.', 'error', err.response)
      })
  }
}

export function getCredentialsForVendor(vendorCode, cb) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')
    axios({
      method: 'get',
      url: `/integrations/api-credentials/?integration_vendor__code=${vendorCode}`,

      headers: {
        Authorization: token,
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.data.results.length >= 1) {
          cb(response.data.results[0])
        }
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Oops! Somethings not right.',
              content: 'We could not get the existing credentials for this vendor'
            },
            8000
          )
        )
        sendDatadogError('Could not retrieve integrations.', 'error', err.response)
      })
  }
}

export function saveAPICredentials(objId, vendorName, data, cb) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')
    axios({
      method: objId ? 'put' : 'post',
      url: objId ? `/integrations/api-credentials/${objId}/` : `integrations/api-credentials/`,

      headers: {
        Authorization: token,
        'Content-Type': 'application/json'
      },
      data
    })
      .then(() => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: 'Success!',
              content: `Your ${sanitizeContent(vendorName)} data has been successfully integrated.`
            },
            8000
          )
        )
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Oops! Somethings not right.',
              content: 'Please check your credentials and try again'
            },
            8000
          )
        )
        sendDatadogError('Could not retrieve integrations.', 'error', err.response)
      })
      .finally(() => {
        if (cb) {
          cb()
        }
      })
  }
}

export function updateIntegrationStreamAPICredentials({ streamId, api_credential_data, cb }) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')
    return (
      axios
        .put(
          `/integrations/integration-stream-self-service/${streamId}/`,
          {
            api_credential_data
          },
          {
            headers: {
              Authorization: token
            },
            timeout: 15000 // 15 seconds
          }
        )
        .then(({ data }) => {
          dispatch(getIntegrationStreams())
          if (cb) {
            cb(data, false)
          }
          return data
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          if (cb) {
            cb(err.response.data, true)
          }
          return err
        })
    )
  }
}

/** Get all Outbound Services */
export function getOutboundServices(call_back) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')
    return axios({
      method: 'get',
      url: `/intsync/outbound-services/`,
      headers: {
        Authorization: token
      },
      timeout: 15000 // 15 seconds
    })
      .then(({ data }) => {
        if (call_back) {
          call_back(data, false)
        }
        return data
      })
      .catch((err) => {
        console.log(err)
        if (call_back) {
          call_back(err.response.data, true)
        }
        return err
      })
  }
}

/** Get MS Teams Auth Code for installatin */
export function getMSTeamsAuthCode(call_back) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')
    return axios({
      method: 'get',
      url: `/intsync/microsoft-teams/get-auth-code/`,
      headers: {
        Authorization: token
      },
      timeout: 15000 // 15 seconds
    })
      .then(({ data }) => {
        if (call_back) {
          call_back(data, false)
        }
        return data
      })
      .catch((err) => {
        console.log(err)
        if (call_back) {
          call_back(err.response.data, true)
        }
        return err
      })
  }
}

/** Saves the integration stream and returns the payload of the API response (the saved stream) */
export function saveIntegrationStream({
  alternate_name,
  connector_feature,
  channel_code,
  existing_api_credential,
  api_credential_data,
  cb
}) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')
    return (
      axios
        .post(
          `/integrations/integration-stream-self-service/`,
          {
            alternate_name,
            connector_feature,
            channel_code,
            existing_api_credential,
            api_credential_data
          },
          {
            headers: {
              Authorization: token
            },
            timeout: 15000 // 15 seconds
          }
        )
        .then(({ data }) => {
          dispatch(getIntegrationStreams())
          if (cb) {
            cb(data, false)
          }
          return data
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          if (cb) {
            cb(err.response.data, true)
          }
          return err
        })
    )
  }
}

export function updateIntegrationStream(
  vendorName,
  integrationStreamID,
  data,
  cb,
  showMsg = false
) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    axios({
      method: 'put',
      url: `/integrations/integration-stream-self-service/${integrationStreamID}/`,
      headers: {
        Authorization: token,
        'Content-Type': 'application/json'
      },
      data
    })
      .then(() => {
        if (showMsg) {
          dispatch(
            createMessage(
              {
                type: 'generic',
                level: 'success',
                header: 'Success!',
                content: `Your ${sanitizeContent(vendorName)}’s name has been updated.`
              },
              8000
            )
          )
        }
        dispatch(getIntegrationStreams())
      })
      .catch((err) => {
        if (showMsg) {
          dispatch(
            createMessage(
              {
                type: 'generic',
                level: 'danger',
                header: `Could not save integration stream for ${vendorName}.`,
                content: 'Please try again'
              },
              8000,
              true
            )
          )
        }

        sendDatadogError(
          `Could not save integration stream for ${vendorName}.`,
          'error',
          err.response
        )
      })
      .finally(() => {
        if (cb) {
          cb()
        }
      })
  }
}

export function deleteIntegrationStream(vendorName, integrationStreamID, cb) {
  return (dispatch, getState) => {
    const token = getState().get('engagement').auth.get('JWT')

    axios
      .delete(`/integrations/integration-stream-self-service/${integrationStreamID}`, {
        headers: {
          Authorization: token
        }
      })
      .then(() => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: 'Success!',
              content: `Your Integration for ${sanitizeContent(
                vendorName
              )} data has been successfully deleted.`
            },
            8000,
            true
          )
        )
        dispatch(getIntegrationStreams())
      })
      .catch((err) => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Oops! Somethings not right.',
              content: 'Please try again'
            },
            8000
          )
        )
        sendDatadogError(
          `Could not delete integration stream for ${vendorName}.`,
          'error',
          err.response
        )
      })
      .finally(() => {
        if (cb) {
          cb()
        }
      })
  }
}

export async function setIntelligenceDetails({ token, queryParams = {} }) {
  try {
    const url = `${process.env.REACT_APP_SERVER_BASE_URL}/reputations/organization/intelligence/summary`
    const response = await axios({
      method: 'get',
      url,
      params: queryParams,

      headers: {
        Authorization: token,
        'Content-Type': 'application/json'
      }
    })
    return response?.data || {}
  } catch (err) {
    sendDatadogError('Could not retrieve integrations for the org.', 'error', err.response)
    return {}
  }
}

export async function getIntelligenceReport({ token }) {
  try {
    const url = `${process.env.REACT_APP_SERVER_BASE_URL}/reputations/organization/intelligence/report`
    const response = await axios({
      method: 'get',
      url,

      headers: {
        Authorization: token,
        'Content-Type': 'application/json'
      }
    })
    return response || {}
  } catch (err) {
    sendDatadogError('Could not retrieve integrations for the org.', 'error', err.response)
    return {}
  }
}

export function configureSlack(code, redirectUri) {
  return async (dispatch) => {
    const url = `${process.env.REACT_APP_SERVER_BASE_URL}/api/integrations/configure/slack`
    fetcher
      .post(url, {
        code,
        redirect_uri: redirectUri
      })
      .then(() => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: 'Success!',
              content: `Your have integrated slack successfully.`
            },
            8000
          )
        )
        dispatch(getIntegrationStreams())
      })
      .catch(() => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Oops! Somethings not right.',
              content: 'Please try again'
            },
            8000
          )
        )
      })
  }
}
